import BaseApi from './base';

class Report extends BaseApi {
    endpoint = 'reports/vehicles';
}

export default new Report();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/report.js